import { render, staticRenderFns } from "./EditApiConfig.vue?vue&type=template&id=3fd33aa0&scoped=true"
import script from "./EditApiConfig.vue?vue&type=script&lang=ts"
export * from "./EditApiConfig.vue?vue&type=script&lang=ts"
import style0 from "./EditApiConfig.vue?vue&type=style&index=0&id=3fd33aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd33aa0",
  null
  
)

export default component.exports